import axios from 'axios'
import {
  getAgentRequest,
  getAgentSuccess,
  getAgentFail,
  approveAgentRequest,
  approveAgentSuccess,
  approveAgentFail,
  disapproveAgentRequest,
  disapproveAgentSuccess,
  disapproveAgentFail,
} from '../../../state/redux/slices/agentSlice.js'

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_API_URL,
  timeout: 30000,
})

export const fetchAgent = agentId => async dispatch => {
  try {
    dispatch(getAgentRequest())
    const token = localStorage.getItem('authToken')
    const response = await api.get(`/v1/agents/agent/users/${agentId}`, {
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
      },
    })
    dispatch(getAgentSuccess(response.data.data))
  } catch (error) {
    dispatch(getAgentFail(error.response?.data?.message || error.message))
  }
}

export const createAgent = agentData => {
  const token = localStorage.getItem('authToken')
  return api.post('v1/agents/agent/users', agentData, {
    headers: {
      Authorization: token ? `Bearer ${token}` : '',
    },
  })
}

export const approveAgent = agentId => async dispatch => {
  try {
    dispatch(approveAgentRequest())
    const token = localStorage.getItem('authToken')
    const response = await api.patch(
      `/v1/agents/validate/${agentId}`,
      {},
      {
        headers: {
          Authorization: token ? `Bearer ${token}` : '',
        },
      }
    )
    dispatch(approveAgentSuccess(response.data))
  } catch (error) {
    dispatch(approveAgentFail(error.response?.data?.message || error.message))
  }
}

export const disapproveAgent = agentId => async dispatch => {
  try {
    dispatch(disapproveAgentRequest())
    const token = localStorage.getItem('authToken')
    const response = await api.patch(
      `/v1/agents/disapprove/${agentId}`,
      {},
      {
        headers: {
          Authorization: token ? `Bearer ${token}` : '',
        },
      }
    )
    const updatedAgent = response.data.data
    dispatch(disapproveAgentSuccess(updatedAgent))
    return updatedAgent
  } catch (error) {
    dispatch(disapproveAgentFail(error.response?.data?.message || error.message))
    throw error
  }
}

export const deactivateAgentAccount = ({ userId, message }) => async dispatch => {
  try {
    const token = localStorage.getItem('authToken')
    const response = await api.post(
      `/v1/admin/deactivate/account/user/${userId}`,
      { message },
      {
        headers: {
          Authorization: token ? `Bearer ${token}` : '',
          'Content-Type': 'application/json',
        },
      }
    )
    return response.data
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message)
  }
}

export const updateAgent = (agentId, agentData) => {
  const token = localStorage.getItem('authToken')
  return api.put(`v1/agents/agent/users/${agentId}`, agentData, {
    headers: {
      Authorization: token ? `Bearer ${token}` : '',
    },
  })
}

export const deleteAgent = agentId => {
  const token = localStorage.getItem('authToken')
  return api.delete(`v1/agents/agent/users/${agentId}`, {
    headers: {
      Authorization: token ? `Bearer ${token}` : '',
    },
  })
}